import React from 'react'
import './ContentBlock.css'
import controlText from '../../resouces/text-icon-active.svg'
import controlPrevious from '../../resouces/control-previous.svg'
import controlNext from '../../resouces/control-next.svg'
import controlPlay from '../../resouces/control-play.svg'
import controlPause from '../../resouces/control-pause.svg'
import AudioManager from "../../managers/AudioManager";
import ObjectData from "../../dataModel/ObjectData";
import Localization from "../../localization";
import lecturerIcon from "../../resouces/lecturer-icon.png"
import StoreManager from "../../managers/StoreManager";
import store from "../../storeDispatcher/store";


type PropsType = {
    object: ObjectData | null,
    objectList: Record<string, ObjectData>,
    selectedLanguage: string | null,
    playingId: String | null,
    isPlaying: Boolean,
    mediaProgress: {
        position: number,
        duration: number,
        progress: number
    }
}


export default class MediaControl extends React.Component<PropsType> {

    state = {
        speekNodeUpdated: false
    };

    componentDidUpdate(prevProps: Readonly<PropsType>, prevState: Readonly<{}>, snapshot?: any): void {
        const {object, selectedLanguage} = this.props;

        this.setSpeakNodeToPlayer(object, selectedLanguage, prevProps.selectedLanguage);
    }


    componentDidMount(): void {
        const {object, selectedLanguage} = this.props;

        this.setSpeakNodeToPlayer(object, selectedLanguage, selectedLanguage);
    }


    setSpeakNodeToPlayer(object: ObjectData | null, selectedLanguage: string | null, prevLanguage: string | null): void {
        let currentSpeakNode = AudioManager.currentSpeakNode;

        if ((object && !currentSpeakNode && !this.state.speekNodeUpdated) || (object && prevLanguage !== selectedLanguage)) {

            const firstSpeekNode = object.firstSpeekNode(selectedLanguage);
            console.log({selectedLanguage, firstSpeekNode, medias: object.mediaEntries.map((it: any) => it.tags.Language)});

            if (firstSpeekNode) {
                AudioManager.stop();
                AudioManager.lastPlayedSpeek = firstSpeekNode[0];
                AudioManager.loadDataFromLastSpeek();

                this.setState({speekNodeUpdated: true});
            }


        }
    }


    onTextMode() {
        StoreManager.addParameters({
            textMode: !store.getState().parameters.textMode,
            currentAvatarId: null
        })
    }


    onPlayPause() {
        const {isPlaying, playingId} = this.props;
        const lastPlayedSpeek = AudioManager.lastPlayedSpeek;

        if (isPlaying) {
            AudioManager.pause();
        }
        else if (lastPlayedSpeek) {
            AudioManager.play(playingId ? lastPlayedSpeek : (lastPlayedSpeek.isSubTrack ? lastPlayedSpeek.parent : lastPlayedSpeek))
        }

    }


    onNext() {
        AudioManager.startNextTrack();
    }


    onPrevious() {
        AudioManager.startPreviousTrack()
    }


    onChangeProgress(e: any) {
        AudioManager.changeAudioPosition(e.target.value);
    }


    durationFromSeconds(duration: number): string {
        const s = Math.trunc(duration);

        const minN = s >= 60 ? Math.trunc(s / 60) : 0;
        const secN = s - minN * 60;

        const minS = minN < 10 ? `0${minN}` : `${minN}`;
        const secS = secN < 10 ? `0${secN}` : `${secN}`;

        return `${minS}:${secS}`;
    }


    goToTheLecturer(lecturer: ObjectData | null = null) {
        const fromObjectId = this.props.object?.objectId
        const objectId = lecturer?.objectId

        if (!objectId || !fromObjectId) {
            return
        }

        window.location.href = (window.location.href.includes('/play/') ? "/play/?" : "/?") + objectId + '&' + fromObjectId;
    }


    render() {
        const {/*object, selectedLanguage, playingId,*/ isPlaying, mediaProgress: {position, duration, progress}, objectList} = this.props;
        let currentSpeakNode = AudioManager.currentSpeakNode;
        currentSpeakNode = currentSpeakNode ? currentSpeakNode.filter(it => it.isPlayable) : currentSpeakNode;

        if (!AudioManager.lastPlayedSpeek) {
            return null
        }

        const speakCount = currentSpeakNode ? currentSpeakNode.length : 0;
        let currentSpeakNumber = currentSpeakNode ? currentSpeakNode.findIndex(it => it.mediaId === AudioManager.lastPlayedSpeek.mediaId) + 1 : 0;

        const lecturer = AudioManager.lastPlayedSpeek.lecturerObjectId ? objectList[AudioManager.lastPlayedSpeek.lecturerObjectId] : null;
        // console.log({lecturer});

        return <div className='MediaBlock'>

            {
                (AudioManager.lastPlayedSpeek && !lecturer) &&
                    <div className='MediaBlockItem'>

                        <img className='MediaLanguageIcon'
                             alt="Language"
                             src={`./res/flags/${AudioManager.lastPlayedSpeek.language}.svg`}/>

                        <div className='grayColored'>
                            {
                                currentSpeakNumber > 0
                                    ? <span>{currentSpeakNumber}/{speakCount} </span>
                                    : <span>&nbsp;</span>
                            }
                        </div>

                    </div>
            }

            {
                (AudioManager.lastPlayedSpeek && lecturer) &&
                <div className='MediaBlockWideItem'>
                    <div className="MediaFlagLeftBlock">
                        <img className='MediaLanguageIcon'
                             alt="Language"
                             src={`./res/flags/${AudioManager.lastPlayedSpeek.language}.svg`}/>

                        <div className='grayColored'>
                            {
                                currentSpeakNumber > 0
                                    ? <span>{currentSpeakNumber}/{speakCount} </span>
                                    : <span>&nbsp;</span>
                            }
                        </div>
                    </div>

                    <div className="MediaLectorBlock"
                         onClick={() => this.goToTheLecturer(lecturer)}>
                        {
                            lecturer.avatarImage &&
                            <i className="MediaLectorIcon fal fa-signal-stream"/>
                        }

                        <img className={lecturer.avatarImage ? "MediaLectorAvatar" : "MediaLectorPlaceholder"}
                             alt=""
                             src={lecturer.avatarImage ? 'data:image/jpeg;base64,' + lecturer.avatarImage : lecturerIcon}/>

                        <div className='grayColored'>
                            {
                               lecturer.getDescription
                            }
                        </div>
                    </div>
                </div>
            }


            <div className='MediaBlockItem'>
                <div className='heavyText'>
                    {
                        AudioManager.lastPlayedSpeek
                            ? AudioManager.lastPlayedSpeek.getDescription
                            : Localization.stringFor("chooseAudioPlay")
                    }
                </div>

                <div className='grayColored'>
                    <small>
                        {
                            AudioManager.lastPlayedSpeek
                                ? AudioManager.lastPlayedSpeek.parentDescription || <br/>
                                : <br/>
                        }
                    </small>
                </div>
            </div>

            <div className='MediaBlockItem'>
                <input className='TrackProgress'
                       onChange={e => this.onChangeProgress(e)}
                       value={progress}
                       type='range'/>

                <div style={{fontSize: '3.5vw', lineHeight: 1}}>
                    <div style={{float: 'left'}}>{this.durationFromSeconds(position)}</div>
                    <div style={{float: 'right'}}>{AudioManager.lastStartedIsAudio ? this.durationFromSeconds(duration) : '00:00'}</div>
                </div>
            </div>

            <div className='MediaBlockItem'>
                {
                    (AudioManager.currentMediaNodeText) &&
                    <img className='ControlBtn'
                         onClick={() => this.onTextMode()}
                         src={controlText}
                         alt="Text mode"/>
                }

                <img className='ControlBtn'
                     onClick={() => this.onPrevious()}
                     src={controlPrevious}
                     alt="Previous"/>

                <img className='ControlBtn'
                     onClick={() => this.onPlayPause()}
                     src={isPlaying ? controlPause : controlPlay}
                     alt="Play/pause"/>

                <img className='ControlBtn'
                     onClick={() => this.onNext()}
                     src={controlNext}
                     alt="Next"/>
            </div>

        </div>
    }

}
